// Calculation(TicketArr[index], OrgGstPercentage, TicketYtcrBasePrice, YTCR_FEE_PERCENT, PAYMENT_GATEWAY_FEE_PERCENT, PAYMENT_GATEWAY_GST_PERCENT, CollectGst, PriceTaxesStatus);

// Me - Organiser / Buys - Participant

export const Calculation = (TicketArr = [], CollectGst, ExcPriceTaxesStatus, AmountArr, RaceCategoryCharges, OtherAmountReset = 0, appliedCoupons = []) => {
  // console.log(TicketArr);
    // console.log(TicketArr, appliedCoupons);
    // console.log(TicketArr, RegistrationGstPercentage, YtcrFee, YtcrGstPercentage, PaymentGatewayPercentage, PaymentGatewayGstPercentage, CollectGst, ExcPriceTaxesStatus, AmountArr);
    let RegistrationGstPercentage = TicketArr ? TicketArr["OrgGstPercentage"] : 0;
    let YtcrFee = TicketArr ? TicketArr["TicketYtcrBasePrice"] : 0;
    let YtcrGstPercentage = TicketArr ? TicketArr["YTCR_FEE_PERCENT"] : 0;
    let PaymentGatewayPercentage = TicketArr ? TicketArr["PAYMENT_GATEWAY_FEE_PERCENT"] : 0;
    let PaymentGatewayGstPercentage = TicketArr ? TicketArr["PAYMENT_GATEWAY_GST_PERCENT"] : 0;
    
    // let coupon_amount = appliedCoupons && appliedCoupons.length > 0 ? appliedCoupons[0].applied_amount : TicketArr["appliedCouponAmount"] !== 0 ? TicketArr["appliedCouponAmount"] : 0;
    let coupon_amount = appliedCoupons && appliedCoupons.length > 0 ? TicketArr["appliedCouponAmount"] : TicketArr["appliedCouponAmount"] !== 0 ? TicketArr["appliedCouponAmount"] : 0;
    // console.log(coupon_amount);
    
    //----------- New added Single ticket to applied coupon code
    TicketArr["Coupon_discount_amt_per_type"] = 0;
    TicketArr["Coupon_discount_amount"] = 0;
    TicketArr["Single_ticket_applied_coupon_amount"] = 0;
    TicketArr["Single_ticket_applied_coupon_tax_amount"] = 0;  // with tax
   
    if(appliedCoupons && appliedCoupons.length > 0){
      TicketArr["Coupon_discount_amt_per_type"] = appliedCoupons[0].discount_amt_per_type;
     
      if(appliedCoupons[0].discount_amt_per_type == 2){
        TicketArr["Coupon_discount_amount"] = appliedCoupons[0].discount_amount;
      }

      if(appliedCoupons[0].discount_amt_per_type == 1){
        TicketArr["Coupon_discount_amount"] = (parseFloat(TicketArr["ticket_price"]) * parseFloat(appliedCoupons[0].discount_percentage)) /100;
      }

      TicketArr["Single_ticket_applied_coupon_amount"] = (parseFloat(TicketArr["ticket_price"]) - TicketArr["Coupon_discount_amount"]);
    }else{
      TicketArr["Single_ticket_applied_coupon_amount"] = parseFloat(TicketArr["ticket_price"]);
    }
    
    TicketArr["Single_ticket_applied_coupon_amount"] = (TicketArr["show_early_bird"] === 1) ? parseFloat(TicketArr["discount_ticket_price"]) : TicketArr["Single_ticket_applied_coupon_amount"];

    //  console.log(TicketArr["Single_ticket_applied_coupon_amount"]);
    //---------- early_bird is yes / no
    const TicketPrice = (TicketArr["show_early_bird"] === 1) ? (parseFloat(TicketArr["discount_ticket_price"]) * TicketArr["count"]) : (parseFloat(TicketArr["ticket_price"] * TicketArr["count"]));
     // (item.hasOwnProperty("appliedCouponId")
    //  console.log(TicketArr["appliedCouponAmount"],TicketArr["count"]);
    //---------- applied Coupon
    // let TicketPriceFloat = TicketArr["appliedCouponCode"] && (TicketArr.hasOwnProperty("appliedCouponAmount")) ? TicketPrice - (parseFloat(TicketArr["appliedCouponAmount"])/parseInt(TicketArr["count"])) : TicketPrice;
    
    let TicketPriceFloat = coupon_amount && coupon_amount !== 0 ? TicketPrice - parseFloat(coupon_amount) : TicketPrice;
    // console.log(TicketPriceFloat);
    //----------- new calculation

    // let ConvenienceFeeBase = TicketArr["ticket_calculation_details"].convenience_fee_base;
    // let NewPlatformFee = TicketArr["ticket_calculation_details"].platform_fees_5_each;
    // let NewPaymentGatewayFee = TicketArr["ticket_calculation_details"].payment_gateway_fees;

    let ConvenienceFeeBase = 0;
    let PlatformFee = 0;
    let NewPlatformFee = 0;
    let NewPaymentGatewayFee = 0;
    let SingleTicketPlatformFee = 0;

   
    // SingleTicketPlatformFee = (SingleTicketPlatformFee - TicketArr["ticket_discount"]);
    
    // console.log(SingleTicketPlatformFee);
    // const YtcrAmount = isNaN(YtcrFee) ? 0 : parseFloat((YtcrFee * (YtcrGstPercentage / 100)).toFixed(2));

    let RegistrationFee;
    const WhoPayYtcrFee = TicketArr["player_of_fee"];
    const WhoPayPaymentGatewayFee = TicketArr["player_of_gateway_fee"];
    let BuyerAmtWithoutPaymentGateway = 0;
    let PaymentGatewayAmount = 0;
    let PaymentGatewayWithGst = 0;
    
    //----------------------------------------
    TicketArr["RegistrationGstPercentage"] = (RegistrationGstPercentage);
    TicketArr["YtcrGstPercentage"] = (YtcrGstPercentage);
    TicketArr["PaymentGatewayPercentage"] = (PaymentGatewayPercentage);
    TicketArr["PaymentGatewayGstPercentage"] = (PaymentGatewayGstPercentage);

    let BuyerPayment;
    let MoneyToOrg;
    let BasePriceGst = 0;
    let Basic_Amount_Gst = 0;

    let SingleTicketBasePriceGst = 0;
    let Single_Ticket_Basic_Amount_Gst = 0;
    
    let GST_On_Convenience_Fees = 0;
    let Total_Convenience_Fees = 0;
    let GST_On_Platform_Fees_Amount = 0;
    let Total_Platform_Fees = 0;
    let Net_Registration_Amount = 0;
    let Payment_Gateway_Buyer = 0;
    let Payment_Gateway_gst_amount = 0;
    let Total_Payment_Gateway = 0;
    let Total_Buyer = 0;
    let Total_Organiser = 0;
    let Convenience_Fee_Amount = 0;

    let SingleTicketAmountWithTax = 0;
    let Single_Ticket_GST_On_Platform_Fees_Amount = 0;
    let Single_Ticket_Total_Platform_Fees = 0;
    let Single_Ticket_Net_Registration_Amount = 0;
    let Single_Ticket_Payment_Gateway_Buyer = 0;
    let Single_Ticket_Payment_Gateway_gst_amount = 0;
    let Single_Ticket_Total_Payment_Gateway = 0;

    const Convenience_Fees_Gst_Percentage = 18;
    const GST_On_Platform_Fees = 18;
    const Payment_Gateway_Gst = 18;

    //-------------- for revenue excel report
    let Excel_Extra_Amount_Payment_Gateway = 0; 
    let Excel_Extra_Amount_Payment_Gateway_Gst = 0; 

    let GstPercentage = 0;
    if (CollectGst === 1 && ExcPriceTaxesStatus === 2) {  // get for organization page
        GstPercentage = 18;
    } else {
        GstPercentage = 0;
    }

    if (CollectGst === 1 && ExcPriceTaxesStatus === 2) { 
        BasePriceGst = TicketPriceFloat !== 0 ? TicketPriceFloat * (GstPercentage / 100) : 0; // GST %
        Basic_Amount_Gst = (parseFloat(BasePriceGst) + TicketPriceFloat);
       
        //-------- Single Ticket
        SingleTicketBasePriceGst = TicketArr["Single_ticket_applied_coupon_amount"] !== 0 ? TicketArr["Single_ticket_applied_coupon_amount"] * (GstPercentage / 100) : 0; // GST %
        Single_Ticket_Basic_Amount_Gst = (parseFloat(SingleTicketBasePriceGst) + TicketPriceFloat);
        //-------------- new added
        TicketArr["Single_ticket_applied_coupon_amount"] = (parseFloat(TicketArr["Single_ticket_applied_coupon_amount"]) + parseFloat(SingleTicketBasePriceGst));
    } else {
        BasePriceGst = '0.00';
        Basic_Amount_Gst = parseFloat(TicketPriceFloat); // registration amt

        //-------- Single Ticket
        SingleTicketBasePriceGst = '0.00';
        Single_Ticket_Basic_Amount_Gst = parseFloat(TicketArr["Single_ticket_applied_coupon_amount"]);
    }
  //  console.log(Basic_Amount_Gst);
     if (RaceCategoryCharges.length > 0 && RaceCategoryCharges && TicketPriceFloat !== 0) {
     
        for (var i = 0; i < RaceCategoryCharges.length; i++) {
          if (RaceCategoryCharges[i]['registration_amount'] >= parseFloat(TicketPriceFloat)){
            NewPaymentGatewayFee = (RaceCategoryCharges[i]['payment_gateway_fee']); // 2 %
            ConvenienceFeeBase = (RaceCategoryCharges[i]['convenience_fee']);
            PlatformFee = (RaceCategoryCharges[i]['platform_fee']);  // 5%
            //----------- new added on 03-12-25
            //NewPlatformFee = (TicketPriceFloat * PlatformFee) /100;
            NewPlatformFee = (Basic_Amount_Gst * PlatformFee) /100;
            break;
          }else if(i === RaceCategoryCharges.length - 1 && RaceCategoryCharges[i]['registration_amount'] <= parseFloat(TicketPriceFloat)){
            //console.log(RaceCategoryCharges[i]['convenience_fee']);
            NewPaymentGatewayFee = (RaceCategoryCharges[i]['payment_gateway_fee']); // 2 %
            ConvenienceFeeBase = (RaceCategoryCharges[i]['convenience_fee']);
            PlatformFee = (RaceCategoryCharges[i]['platform_fee']);  // 5%
            //----------- new added on 03-12-25
            //NewPlatformFee = (TicketPriceFloat * PlatformFee) /100;
            NewPlatformFee = (Basic_Amount_Gst * PlatformFee) /100;
            break;
          }
        }
    }else{
      if (Array.isArray(AmountArr) && AmountArr.length > 0) {
          //--------- New added
          for (var i = 0; i < RaceCategoryCharges.length; i++) {
            NewPaymentGatewayFee = (RaceCategoryCharges[i]['payment_gateway_fee']); // 2 %
            ConvenienceFeeBase = (RaceCategoryCharges[i]['convenience_fee']);
            PlatformFee = (RaceCategoryCharges[i]['platform_fee']);  // 5%
            //----------- new added on 03-12-25
            //NewPlatformFee = (TicketPriceFloat * PlatformFee) /100;
            NewPlatformFee = (Basic_Amount_Gst * PlatformFee) /100;
            break;
          }
      }
    }

    SingleTicketPlatformFee = (TicketArr["Single_ticket_applied_coupon_amount"] * PlatformFee) /100;

    GST_On_Convenience_Fees = parseFloat(Convenience_Fee_Amount) * (Convenience_Fees_Gst_Percentage / 100); // GST 18%
    Total_Convenience_Fees = (parseFloat(Convenience_Fee_Amount) + GST_On_Convenience_Fees);
    GST_On_Platform_Fees_Amount = NewPlatformFee * (GST_On_Platform_Fees / 100); // GST 18%
    Total_Platform_Fees = (parseFloat(NewPlatformFee) + parseFloat(GST_On_Platform_Fees_Amount));
    Net_Registration_Amount = (parseFloat(Basic_Amount_Gst) + parseFloat(Total_Convenience_Fees) + parseFloat(Total_Platform_Fees));

    //--------- Single Ticket
    Single_Ticket_GST_On_Platform_Fees_Amount  = SingleTicketPlatformFee * (GST_On_Platform_Fees / 100); // GST 18%
    Single_Ticket_Total_Platform_Fees = (parseFloat(SingleTicketPlatformFee) + parseFloat(Single_Ticket_GST_On_Platform_Fees_Amount));
    Single_Ticket_Net_Registration_Amount = (parseFloat(Single_Ticket_Basic_Amount_Gst) + parseFloat(Single_Ticket_Total_Platform_Fees));

    // console.log(Single_Ticket_GST_On_Platform_Fees_Amount, Single_Ticket_Total_Platform_Fees, Single_Ticket_Net_Registration_Amount);
   
    let totalPlatformFee = 0;
    let totalTaxes = 0;
    let Extra_Amount_Payment_Gateway = 0; 
    let Extra_Amount_Payment_Gateway_Gst = 0; 
    let Extra_Amount = 0; 
    let Extra_Amount_Org_Gst = 0; // 18%
    let itemValue = 0;
    
    if (parseInt(WhoPayYtcrFee) === 1 && parseInt(WhoPayPaymentGatewayFee) === 1) {  //Organiser + Organiser
        // console.log(AmountArr);
        
        if (Array.isArray(AmountArr) && AmountArr.length > 0) {
          for (let i of AmountArr) {
            if (
              Number(i.ticket_id) === Number(TicketArr.id) &&
              i.amtFlag === true
            ) {
              itemValue += Number(i.value);
            }
          }
        }

        Extra_Amount = itemValue;
        Extra_Amount_Org_Gst = GstPercentage > 0 ? itemValue * (GstPercentage / 100) : 0;
      
        // calculations AFTER total is ready
        if(NewPaymentGatewayFee > 0){
          Excel_Extra_Amount_Payment_Gateway = (parseFloat(Extra_Amount) + parseFloat(Extra_Amount_Org_Gst)) * (NewPaymentGatewayFee / 100);
        }else{
          Excel_Extra_Amount_Payment_Gateway = 0;
        }

        if(Excel_Extra_Amount_Payment_Gateway > 0){
          Excel_Extra_Amount_Payment_Gateway_Gst =
            Excel_Extra_Amount_Payment_Gateway * (Payment_Gateway_Gst / 100);
        }else{
          Excel_Extra_Amount_Payment_Gateway_Gst =
            Extra_Amount * (Payment_Gateway_Gst / 100);
        }
          // console.log(Excel_Extra_Amount_Payment_Gateway_Gst);
        Extra_Amount_Payment_Gateway = Excel_Extra_Amount_Payment_Gateway;
        Extra_Amount_Payment_Gateway_Gst = Excel_Extra_Amount_Payment_Gateway_Gst;
     
        Payment_Gateway_Buyer = Basic_Amount_Gst * (NewPaymentGatewayFee / 100); // 1.85%
        Payment_Gateway_gst_amount = Payment_Gateway_Buyer * (Payment_Gateway_Gst / 100); //18%
        Total_Payment_Gateway = (parseFloat(Payment_Gateway_Buyer) + parseFloat(Payment_Gateway_gst_amount));

        BuyerPayment = Basic_Amount_Gst;  // yes
        // console.log(BuyerPayment);
        
        //----------------------------------
        totalPlatformFee = 0;
        totalTaxes = 0 ; // parseFloat(BasePriceGst);

        //---------- org amount
        MoneyToOrg = (parseFloat(BuyerPayment) - parseFloat(Total_Payment_Gateway) - parseFloat(Total_Platform_Fees) - parseFloat(Total_Convenience_Fees));

        //----- Single Ticket
        SingleTicketAmountWithTax = Single_Ticket_Basic_Amount_Gst;

    }
    else if (parseInt(WhoPayYtcrFee) === 2 && parseInt(WhoPayPaymentGatewayFee) === 2) {  // Participant + Participant
        
        //--------additional amt
        let itemValue = 0;
        if (AmountArr && Array.isArray(AmountArr) && AmountArr.length > 0) {
          for (let i of AmountArr) {

            if(parseFloat(i.ticket_id) === TicketArr["id"] && i.amtFlag === true){
              itemValue += parseFloat(i.value);
              Extra_Amount = itemValue;
            } 
          }

          // Organiser 18% GST on extra amount
          if(GstPercentage > 0){
            Extra_Amount_Org_Gst = Extra_Amount * (GstPercentage / 100);
          }
          
          Extra_Amount_Payment_Gateway = (Extra_Amount + Extra_Amount_Org_Gst) * (PlatformFee / 100); //5%
          Extra_Amount_Payment_Gateway_Gst = Extra_Amount_Payment_Gateway * (GST_On_Platform_Fees / 100); //18%
          // console.log(Extra_Amount, Extra_Amount_Payment_Gateway, Extra_Amount_Payment_Gateway_Gst);

          //-------------- for revenue excel report
          Excel_Extra_Amount_Payment_Gateway = Extra_Amount_Payment_Gateway; 
          Excel_Extra_Amount_Payment_Gateway_Gst = Extra_Amount_Payment_Gateway_Gst; 

        }
        
        // else if(OtherAmountReset === 0){
        //     Payment_Gateway_Buyer = Net_Registration_Amount * (NewPaymentGatewayFee / 100); 
        // }else{
        //     Payment_Gateway_Buyer = Net_Registration_Amount * (NewPaymentGatewayFee / 100);
        // }
        // console.log(Extra_Amount_Payment_Gateway, Extra_Amount_Payment_Gateway_Gst);
       
       
        //----------------------------------
        // console.log(NewPlatformFee, Payment_Gateway_Buyer);
        if(Excel_Extra_Amount_Payment_Gateway !== 0){
          totalPlatformFee = parseFloat(NewPlatformFee) + parseFloat(Excel_Extra_Amount_Payment_Gateway);
        }else{
          totalPlatformFee = parseFloat(NewPlatformFee);
        }

        if(Excel_Extra_Amount_Payment_Gateway !== 0){
          totalTaxes = parseFloat(GST_On_Platform_Fees_Amount) + parseFloat(Excel_Extra_Amount_Payment_Gateway_Gst);
        }else{
          totalTaxes =  parseFloat(GST_On_Platform_Fees_Amount);
        }
        
        //------ new added on 30-06-26
        BuyerAmtWithoutPaymentGateway  =  (parseFloat(Basic_Amount_Gst) + totalPlatformFee + totalTaxes);
        Total_Payment_Gateway          =  (parseFloat(BuyerAmtWithoutPaymentGateway) * (NewPaymentGatewayFee / 100)); 
        Payment_Gateway_Buyer          =  parseFloat(Total_Payment_Gateway)
        Payment_Gateway_gst_amount     =  (parseFloat(Total_Payment_Gateway) * 0.18); // 18% GST

         //----------------------
       // Payment_Gateway_Buyer = Net_Registration_Amount * (NewPaymentGatewayFee / 100); 
        // Payment_Gateway_gst_amount = Payment_Gateway_Buyer * (Payment_Gateway_Gst / 100); //18%
        // Total_Payment_Gateway = (parseFloat(Payment_Gateway_Buyer) + parseFloat(Payment_Gateway_gst_amount));
       
        BuyerPayment = (parseFloat(BuyerAmtWithoutPaymentGateway) + parseFloat(Total_Payment_Gateway) + parseFloat(Payment_Gateway_gst_amount));

        //---------- org amount
        MoneyToOrg = parseFloat(Extra_Amount) + parseFloat(Extra_Amount_Org_Gst) + (parseFloat(Single_Ticket_Basic_Amount_Gst));
        // console.log(MoneyToOrg, BuyerPayment, Total_Platform_Fees) - parseFloat(Total_Platform_Fees)
        //----- Single Ticket
        SingleTicketAmountWithTax = Single_Ticket_Net_Registration_Amount;
    }
    else if (parseInt(WhoPayYtcrFee) === 1 && parseInt(WhoPayPaymentGatewayFee) === 2) { // Organiser + Participant
        
        let itemValue = 0;
        if (AmountArr && Array.isArray(AmountArr) && AmountArr.length > 0) {
          for (let i of AmountArr) {
          
            if(parseFloat(i.ticket_id) === TicketArr["id"] && i.amtFlag === true){
              itemValue += parseFloat(i.value);
               Extra_Amount = itemValue;

              // Organiser 18% GST on extra amount
              if(GstPercentage > 0){
                Extra_Amount_Org_Gst = itemValue * (GstPercentage / 100);
                itemValue += Extra_Amount_Org_Gst; 
              }
            }

            //-------------- for revenue excel report
            Excel_Extra_Amount_Payment_Gateway = itemValue * (PlatformFee / 100); // 5%
            Excel_Extra_Amount_Payment_Gateway_Gst = Excel_Extra_Amount_Payment_Gateway * (GST_On_Platform_Fees / 100); //18%
          }
        }

        Payment_Gateway_Buyer = Basic_Amount_Gst * (NewPaymentGatewayFee / 100); // 1.85%
        Payment_Gateway_gst_amount = Payment_Gateway_Buyer * (Payment_Gateway_Gst / 100); //18%
        Total_Payment_Gateway = (parseFloat(Payment_Gateway_Buyer) + parseFloat(Payment_Gateway_gst_amount));
        BuyerPayment = (parseFloat(Basic_Amount_Gst) + parseFloat(Total_Payment_Gateway));
    
        //----------------------------------
        totalPlatformFee = parseFloat(Payment_Gateway_Buyer);
        totalTaxes =  parseFloat(Payment_Gateway_gst_amount);  // parseFloat(BasePriceGst) +

        //---------- org amount
        MoneyToOrg = parseFloat(Extra_Amount) + parseFloat(Extra_Amount_Org_Gst) + (parseFloat(BuyerPayment) - parseFloat(Total_Payment_Gateway) - parseFloat(Total_Platform_Fees) - parseFloat(Total_Convenience_Fees));

        //----- Single Ticket 
        Single_Ticket_Payment_Gateway_Buyer = Single_Ticket_Basic_Amount_Gst * (NewPaymentGatewayFee / 100); 
        Single_Ticket_Payment_Gateway_gst_amount = Single_Ticket_Payment_Gateway_Buyer * (Payment_Gateway_Gst / 100); //18%
        Single_Ticket_Total_Payment_Gateway = (parseFloat(Single_Ticket_Payment_Gateway_Buyer) + parseFloat(Single_Ticket_Payment_Gateway_gst_amount));

        SingleTicketAmountWithTax = (parseFloat(Single_Ticket_Basic_Amount_Gst) + parseFloat(Single_Ticket_Total_Payment_Gateway));
    }
    else if (parseInt(WhoPayYtcrFee) === 2 && parseInt(WhoPayPaymentGatewayFee) === 1) { // Participant + Organiser
        
        //--------additional amt
        let itemValue = 0;
        if (AmountArr && Array.isArray(AmountArr) && AmountArr.length > 0) {
          for (let i of AmountArr) {
            if(parseFloat(i.ticket_id) === TicketArr["id"] && i.amtFlag === true){
              itemValue += parseFloat(i.value);
              Extra_Amount = itemValue;

              // Organiser 18% GST on extra amount
              if(GstPercentage > 0){
                Extra_Amount_Org_Gst = itemValue * (GstPercentage / 100);
                itemValue += Extra_Amount_Org_Gst; 
              }
            }
           
            Payment_Gateway_Buyer = (itemValue + Net_Registration_Amount) * (NewPaymentGatewayFee / 100); // 1.85%

            //-------------- for revenue excel report
            Excel_Extra_Amount_Payment_Gateway = itemValue * (PlatformFee / 100); // 2%
            Excel_Extra_Amount_Payment_Gateway_Gst = Excel_Extra_Amount_Payment_Gateway * (GST_On_Platform_Fees / 100); //18%
          }
        }else if(OtherAmountReset === 0){
            Payment_Gateway_Buyer = Net_Registration_Amount * (NewPaymentGatewayFee / 100);
        }else{
            Payment_Gateway_Buyer = Net_Registration_Amount * (NewPaymentGatewayFee / 100);
        }

        Payment_Gateway_gst_amount = Payment_Gateway_Buyer * (Payment_Gateway_Gst / 100); //18%
        Total_Payment_Gateway = (parseFloat(Payment_Gateway_Buyer) + parseFloat(Payment_Gateway_gst_amount));
      
        BuyerPayment = (parseFloat(Basic_Amount_Gst) + parseFloat(Total_Convenience_Fees) + parseFloat(Total_Platform_Fees) );
       
        //----------------------------------
        totalPlatformFee = parseFloat(Convenience_Fee_Amount) + parseFloat(NewPlatformFee);
        totalTaxes =  parseFloat(GST_On_Convenience_Fees) + parseFloat(GST_On_Platform_Fees_Amount);

        //---------- org amount
        MoneyToOrg = parseFloat(Extra_Amount) + parseFloat(Extra_Amount_Org_Gst) + (parseFloat(BuyerPayment) - parseFloat(Total_Payment_Gateway) - parseFloat(Total_Platform_Fees) - parseFloat(Total_Convenience_Fees));

        //----- Single Ticket 
         SingleTicketAmountWithTax = (parseFloat(Single_Ticket_Basic_Amount_Gst) + parseFloat(Single_Ticket_Total_Platform_Fees) );
    }
    
    //----------------------------------------------------------------------------
    TicketArr["Extra_Amount"] = parseFloat(Extra_Amount).toFixed(2);
    TicketArr["Extra_Amount_Org_Gst"] = parseFloat(Extra_Amount_Org_Gst).toFixed(2);
    TicketArr["Extra_Amount_Payment_Gateway"] = parseFloat(Extra_Amount_Payment_Gateway).toFixed(2);
    TicketArr["Extra_Amount_Payment_Gateway_Gst"] = parseFloat(Extra_Amount_Payment_Gateway_Gst).toFixed(2);
    
    //-------------- for revenue excel report
    TicketArr["Excel_Extra_Amount_Payment_Gateway"] = parseFloat(Excel_Extra_Amount_Payment_Gateway).toFixed(2);
    TicketArr["Excel_Extra_Amount_Payment_Gateway_Gst"] = parseFloat(Excel_Extra_Amount_Payment_Gateway_Gst).toFixed(2);
    
    TicketArr["RegistrationFee"] = parseFloat(BasePriceGst).toFixed(2);
    TicketArr["Convenience_Fee"] = parseFloat(Convenience_Fee_Amount).toFixed(2);
    TicketArr["Platform_Fee"] = parseFloat(NewPlatformFee).toFixed(2);
    TicketArr["Total_Platform_Fee"] = parseFloat(totalPlatformFee).toFixed(2);
    TicketArr["Payment_Gateway_Charges"] = parseFloat(Payment_Gateway_Buyer).toFixed(2);
   
    if(Extra_Amount_Org_Gst > 0){
      TicketArr["Registration_Fee_GST"] = parseFloat(BasePriceGst+Extra_Amount_Org_Gst).toFixed(2);
    }else{
      TicketArr["Registration_Fee_GST"] = parseFloat(BasePriceGst).toFixed(2);
    }
    // TicketArr["Registration_Fee_GST"] = parseFloat(BasePriceGst+Extra_Amount_Org_Gst).toFixed(2);
    TicketArr["Convenience_Fee_GST_18"] = parseFloat(GST_On_Convenience_Fees).toFixed(2);
    TicketArr["Platform_Fee_GST_18"] = parseFloat(GST_On_Platform_Fees_Amount).toFixed(2);
    TicketArr["Payment_Gateway_GST_18"] = parseFloat(Payment_Gateway_gst_amount).toFixed(2);
    TicketArr["Payment_Gateway_Fee"] = parseFloat(NewPaymentGatewayFee).toFixed(2);
    TicketArr["Total_Taxes"] = parseFloat(totalTaxes).toFixed(2);
    
    TicketArr["BuyerAmtWithoutPaymentGateway"] = parseFloat(BuyerAmtWithoutPaymentGateway).toFixed(2);
    
    // TicketArr["Main_Price"] = parseFloat(TicketPriceFloat).toFixed(2);
    TicketArr["Main_Price"] = parseFloat(Basic_Amount_Gst).toFixed(2);
    
    TicketArr["CollectGst"] = CollectGst; 
    TicketArr["ExcPriceTaxesStatus"] = ExcPriceTaxesStatus;
    // console.log(TicketArr);
    // console.log(BuyerPayment,MoneyToOrg);
    TicketArr["BuyerPayment"] = TicketArr["count"] !== 0 ? parseFloat(BuyerPayment).toFixed(2) : 0;
    TicketArr["OrgPayment"] = parseFloat(MoneyToOrg).toFixed(2);
   
    TicketArr["total_buyer"] = parseFloat(BuyerPayment).toFixed(2);
    // TicketArr["to_organiser"] = parseFloat(MoneyToOrg).toFixed(2);
    TicketArr["to_organiser"] = parseFloat(SingleTicketAmountWithTax).toFixed(2);
    // console.log(TicketArr);
    TicketArr["SingleTicketAmountWithTax"] = parseFloat(SingleTicketAmountWithTax).toFixed(2);
    TicketArr["Single_ticket_applied_coupon_amount"] = parseFloat(TicketArr["Single_ticket_applied_coupon_amount"]).toFixed(2);
    TicketArr["Single_Ticket_Total_Platform_Fees"] = parseFloat(Single_Ticket_Total_Platform_Fees).toFixed(2);
    // console.log(TicketArr);
    return TicketArr;
};

